import DeterminateDateRangeInput from "features/dateRange/DeterminateDateRangeInput";
import { useGetAllOfficesQuery } from "app/api/offices";
import { useGetAllDepartmentsQuery } from "app/api/departments";
import MultiSelect from "components/MultiSelect";

type Filters = {
  fromDate: Date;
  toDate: Date;
  officeIds: number[] | null;
  departmentIds: number[] | null;
};

type AbsenceFiltersProps = {
  filters: Filters;
  onChange: (filters: Filters) => void;
};

const AbsenceFilters: React.FC<AbsenceFiltersProps> = (props) => {
  const { filters, onChange } = props;
  const { fromDate, toDate, officeIds, departmentIds } = filters;

  const { data: offices } = useGetAllOfficesQuery();
  const { data: departments } = useGetAllDepartmentsQuery();

  const updateFilters = (newFilters: Partial<Filters>) => {
    onChange({ ...filters, ...newFilters });
  };

  return (
    <>
      <DeterminateDateRangeInput
        startText="Från"
        endText="Till"
        value={[fromDate, toDate]}
        onChange={([fromDate, toDate]) => updateFilters({ fromDate, toDate })}
      />

      <MultiSelect
        label="Avdelningar"
        value={departmentIds ?? []}
        onChange={(value) => updateFilters({ departmentIds: value?.length ? value : null })}
        options={
          departments?.map((department) => ({ id: department.id, name: department.name })) ?? []
        }
      />

      <MultiSelect
        label="Kontor"
        value={officeIds ?? []}
        onChange={(value) => updateFilters({ officeIds: value?.length ? value : null })}
        options={offices?.map((office) => ({ id: office.id, name: office.name })) ?? []}
      />
    </>
  );
};

export default AbsenceFilters;
